import { useDeferredValue, useMemo } from "react";

import { take } from "~/tools/take";
import { Tuple } from "~/tools/tuple";

import type { SpecificRange, TimeRange } from "../../app/state/view/timeline/TimeRange";

import type { TimeSeries } from "./time-series";

export function useVisibleTimeSeries({
	timeRange,
	timeSeries,
	maxVisibleTimeSeriesCount,
}: {
	timeRange: TimeRange;
	timeSeries: ReadonlyArray<TimeSeries>;
	maxVisibleTimeSeriesCount: number | undefined;
}): [ReadonlyArray<TimeSeries>, SpecificRange] {
	const tuple = useMemo(() => {
		const specificRange = timeRange.toSpecific();

		if (maxVisibleTimeSeriesCount == null || maxVisibleTimeSeriesCount >= timeSeries.length) {
			return Tuple(timeSeries, specificRange);
		}

		return Tuple(take(timeSeries, maxVisibleTimeSeriesCount - 1), specificRange);
	}, [timeRange, timeSeries, maxVisibleTimeSeriesCount]);

	return useDeferredValue(tuple);
}
